import React from "react";
import auth from "../../services/authService";
import "./SideDrawer.css";
import { NavLink } from "react-router-dom";

const SideDrawer = ({ show }) => {
  let drawerClasses = "side-drawer";
  if (show) {
    drawerClasses = "side-drawer open";
  }

  const user = auth.getCurrentUser();

  return (
    <nav className={drawerClasses}>
      <ul>
        <li>{user && <NavLink to="/">Home</NavLink>}</li>
        {user && <NavLink to="/clients">Client Attest</NavLink>}
        <li>{user && <NavLink to="/user">Settings</NavLink>}</li>
        <li>
          {user && (
            <a
              href="https://portal.vicuscapital.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Portal
            </a>
          )}
        </li>
        <li>
          {!user && <NavLink to="/login">Login</NavLink>}
          {user && <NavLink to="/logout">Logout</NavLink>}
        </li>
      </ul>
    </nav>
  );
};

export default SideDrawer;
